import axios from 'axios';
import httpStatuses from '../constants/httpStatuses';

import { createLogger } from '../lib/logger';

const logger = createLogger('api/client');

const getDefaultClient = () => {
  const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json', 'X-Source': 'blue' },
  });

  client.interceptors.request.use(
    config => {
      return config;
    },
    error => {
      error.message = `DefaultClient::interceptor::request error - ${error.message}`;
      logger.error(error);
      return Promise.reject(error);
    },
  );

  client.interceptors.response.use(
    response => response,
    error => {
      const errorMessage = error ? error.message : 'An error ocurred';
      const httpStatus = error.response ? error.response.status : null;

      if (httpStatus === httpStatuses.UNAUTHORIZED) {
        window.location.replace(`/${window.location.pathname.split('/')[1]}/sessao-expirada`); // TODO: Find better way to redirect
      }

      logger.error(
        `DefaultClient::interceptor::response status:${httpStatus} message:${errorMessage}`,
      );

      return Promise.reject(error);
    },
  );

  return client;
};

const getPrivateClient = token => {
  const client = getDefaultClient();

  client.interceptors.request.use(
    config => {
      if (token) {
        config.headers.Authorization = `token ${token}`;
      }

      return config;
    },
    error => {
      error.message = `PrivateClient::interceptor::request error - ${error.message}`;
      logger.error(error);
      return Promise.reject(error);
    },
  );

  return client;
};

const getEldoradoClient = (isBrandURL = false) =>
  axios.create({
    baseURL: isBrandURL
      ? process.env.REACT_APP_ELDORADO_BRAND_API_URL
      : process.env.REACT_APP_ELDORADO_API_URL,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });

const publicClient = getDefaultClient();

const privateClient = token => getPrivateClient(token);

const eldoradoClient = getEldoradoClient();

const eldoradoBrandClient = getEldoradoClient(true);

export { publicClient, privateClient, eldoradoClient, eldoradoBrandClient };
